<template>
  <div class="allBox">
    <div class="title">
      <strong @click="$router.go(-1)" style="cursor: pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span>创建整单折扣活动</span>
    </div>
    <div class="href">
      <div class="item"><span @click="go(133)">活动基础信息</span></div>
      <div class="item"><span @click="go(358)">活动日期</span></div>
      <div class="item"><span @click="go(884)">活动规则</span></div>
    </div>
    <div class="scroll">
      <div class="mainBox">
        <div class="card">
          <div class="cardBody">
            <div class="left">
              <img src="../../assets/images/base1.svg" alt="" />
            </div>
            <div class="right">
              <div class="top">整单折扣活动介绍</div>
              <div class="bottom">
                对订单进行整体折扣，可设置不参与折扣的菜品。例：整单8折，酒水除外。
              </div>
            </div>
          </div>
        </div>
        <h3 class="textTitle">活动基础信息</h3>
        <el-form label-width="112px">
          <el-form-item label="活动名称" required>
            <el-input
              style="width: 415px"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="展示名称">
            <el-input style="width: 415px" placeholder="请输入"></el-input>
            <div class="labelMore">
              自定义小程序商家详情页活动展示名称
              <span style="color: #c62d2d">（该功能目前不支持小程序2.0）</span>
              <span class="f6" style="margin-left: 16px">查看示例</span>
            </div>
          </el-form-item>
          <el-form-item label="活动渠道" required>
            <el-checkbox-group v-model="checkedList">
              <el-checkbox label="收银机" disabled></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <h3 class="textTitle">活动日期</h3>
          <el-form-item label="活动日期" required>
            <el-radio-group v-model="hdrq">
              <el-radio :label="1">永久有效</el-radio>
              <el-radio :label="0">自定义日期</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="hdrq == 0" label="自定义日期" required>
            <el-date-picker
              value-format="yyyy-mm-dd"
              v-model="dateRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="f6" @click="showMoreTime">
              {{ moreTimeText }}更多设置
              <i
                style="
                  transform: translateY(2px);
                  font-weight: 600;
                  font-size: 16px;
                "
                class="el-icon-arrow-down"
                v-if="isShowMoreTime == false"
              ></i>
              <i
                style="
                  transform: translateY(2px);
                  font-weight: 600;
                  font-size: 16px;
                "
                class="el-icon-arrow-up"
                v-if="isShowMoreTime == true"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="不可用日期" v-if="isShowMoreTime == true">
            <div
              class="item"
              v-for="(ite, index) in unuseDateList"
              style="margin-bottom: 6px"
              :key="index"
            >
              <el-date-picker
                v-model="ite.time"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                style="aspect-ratio: 1/1"
                icon="el-icon-minus"
                circle
                @click="reduceUnuseDate(index)"
              ></el-button>
            </div>
            <span class="f6" @click="addUnuseDate">添加一个日期段</span>
            <div style="color: #666">该促销活动在指定日期不生效</div>
          </el-form-item>
          <el-form-item label="活动星期" required class="flexLabel" v-if="isShowMoreTime == true">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <el-checkbox-group
              v-model="checkedDays"
              @change="handleCheckedDaysChange"
            >
              <el-checkbox
                v-for="(item, index) in days"
                :label="item"
                :key="index"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动时间" v-if="isShowMoreTime == true">
            <div v-for="(item,i) in activeTimeList" :key="i">
              <el-time-picker
                style="width: 128px"
                v-model="item.startTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <span style="color: #333; margin: 0 8px">至</span>
              <el-time-picker
                style="width: 128px"
                v-model="item.endTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <el-button
                style="aspect-ratio: 1/1"
                icon="el-icon-minus"
                circle
                @click="reduceActiveDate(i)"
              ></el-button>
            </div>
            <span class="f6" @click="addUseDate">添加一个时间段</span>
          </el-form-item>
          <h3 class="textTitle">活动规则</h3>
          <el-form-item label="整单折扣率">
            <el-input style="width: 180px">
              <!-- <span slot="suffix" class="suffixIcon">%</span> -->
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="适用菜品">
            <el-radio-group v-model="radio">
              <el-radio :label="0">全部菜品</el-radio>
              <el-radio :label="1">部分可用</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="diaBox">
            <div class="inner">
              <div class="left">
                <span class="pcfn" style="margin-right: 8px"><span v-if="radio==0">排除</span><span v-if="radio==1">指定</span>分类</span>
              </div>
              <div class="right">
                <div class="top">
                  <span class="select" @click="showCategoryDialog">选择分类 (已选{{confirmSelectCategoryList.length}}个) </span>
                  <span class="c9"
                    >如选择“指定类别”，后期分类中增加菜品自动适用当前活动</span
                  >
                </div>
                <div class="bottom">
                  <!-- <span class="item" v-for="(i, index) in 120" :key="index">
                    测试
                  </span> -->
                  <el-tag type="info" class="mr5" @close='delConfirmSelect(index)' closable v-for="(item,index) in confirmSelectCategoryList" :key="index">{{item.categoryName}}</el-tag>
                </div>
              </div>
            </div>
          </div>

          <div class="diaBox">
            <div class="inner">
              <div class="left">
                <span class="pcfn" style="margin-right: 8px"><span v-if="radio==0">排除</span><span v-if="radio==1">指定</span>菜品</span>
              </div>
              <div class="right">
                <div class="top">
                  <span class="select" @click="showDishesDialog">选择菜品 (已选6个) </span>
                  <span class="c9"
                    >如选择“指定类别”，后期分类中增加菜品自动适用当前活动</span
                  >
                </div>
                <div class="bottom">
                  <span class="item" v-for="(i, index) in 40" :key="index">
                    测试
                  </span>
                </div>
              </div>
            </div>
          </div>
          <el-form-item label="活动说明" style="margin-top: 16px">
            <el-input
              class="myTextArea"
              type="textarea"
              placeholder="请输入内容"
              v-model="textarea"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="save">
      <el-button class="cancel">取消</el-button>
      <el-button class="sumbit">保存</el-button>
    </div>

  <!-- 菜品分类弹框 -->
  <el-dialog
  title="选择分类"
  :visible.sync="catogaryDialog"
  width="600px"
  :before-close="handleClose">
  <el-row>
     <el-form>
         <el-col :span="24" style="text-align:center;">
            <!-- <el-input  v-model="catogaryForm.catogaryName" @input="getCatogaryList" placeholder="请输入搜索分类名称"></el-input> -->
            <el-input placeholder="输入关键字进行过滤" clearable v-model="filterText"> </el-input>
         </el-col>
     </el-form>
  </el-row>
  <div style="height:300px;overflow:scroll;border-bottom:1px solid #e8e8e8;" class="mt20">
    <el-tree
        node-key="id"
        :data="categoryTreeDate"
        :props="props"
        show-checkbox
        :default-checked-keys='defaultList'
        :filter-node-method="filterNode"
        ref="tree"
        @check="handleCheckChange">
    </el-tree>
  </div>
  <el-row class="pd24">
    <el-col :span="24" class="hasSelectBox">
        <div>已选择({{selectCategoryList.length}})</div>
        <div class="select" @click="clearCategoryAll">清空</div>
    </el-col>
    <el-col :span="24" style="padding-top:5px;">
     <el-tag type="info" class="mr5" @close='delSelectCategory(index)' closable v-for="(item,index) in selectCategoryList" :key="index">{{item.categoryName}}</el-tag>
    </el-col>
  </el-row>
  <span slot="footer" class="dialog-footer">
    <el-button @click="catogaryDialog = false" class="cancel">取 消</el-button>
    <el-button type="primary" @click="categoryConfirm" class="sumbit">确 定</el-button>
  </span>
</el-dialog>

  <DishesDialog :dishesDialogVisible="isShowDishes" @handleDishesClose='dishesDialogClose'></DishesDialog>
  
  </div>
</template>

<script>
import DishesDialog from './components/DishesDialog.vue';
export default {
components:{
    DishesDialog
  },
  data() {
    return {
        isShowDishes:false,
      catogaryDialog:false,
      isShowMoreTime: false,
      moreTimeText: "展开",
      dataMore: false,
      textarea: "",
      radio: 0,
      value: "",
      dateRange: null,
      checkAll: true,
      isIndeterminate: false,
      days: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      checkedList: ["收银机"],
      hdrq: 1,
      checkedDays: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      unuseDateList:[],
      pickerOptions:{
        //限制日期
        disabledDate(time){
           return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      activeTimeList:[{startTime:'',endTime:''}],
      props:{
          label: 'categoryName',
          children: ''
        },
      categoryTreeDate:[],
      catogaryForm:{
        catogaryName:'',
      },
      filterText:'',
      selectCategoryList:[],
      confirmSelectCategoryList:[],
      defaultList:[],
    };
  },
  created(){
    this.getCatogaryList()
  },
   watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },

  methods: {

    // 菜品弹框返回
    dishesDialogClose(e){
       this.isShowDishes = e
    },
    //
    showDishesDialog(){
        this.isShowDishes = true
    },
    //清空已选分类
    clearCategoryAll(){
        this.selectCategoryList = []
        this.defaultList = []
        this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys( this.defaultList);
      });
    },
    //删除弹框分类选项
    delSelectCategory(index){
       this.selectCategoryList.splice(index,1)
       let list = []
       this.selectCategoryList.forEach(e => {
           list.push(e.id)
       })
       this.defaultList = list
       this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys( this.defaultList);
      });
       console.log('defaultList',this.defaultList);
    },
    //删除页面分类选择
    delConfirmSelect(index){
        this.confirmSelectCategoryList.splice(index,1)
    },
    // 树筛选
    filterNode(value, data) {
        console.log(value,data);
        if (!value) return true;
        return data.categoryName.indexOf(value) !== -1;
    },
    handleClose(){
      this.catogaryDialog = false
      this.getCatogaryList()
    },
    //菜品分类选择确定
    categoryConfirm(){
       this.confirmSelectCategoryList = this.selectCategoryList
       this.catogaryDialog = false
    },
    showCategoryDialog(){
       this.catogaryDialog = true
       let list = []
       this.confirmSelectCategoryList.forEach(e => {
          list.push(e.id)
       })
       this.defaultList = list
       this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys( this.defaultList);
      });
    },
    //查询菜品分类接口
    getCatogaryList(){
      let data = {}
    //   data.isCombo = 0
    //   data.categoryName = this.catogaryForm.catogaryName
      data.merchantCode = localStorage.getItem('merchantCode')
      this.$http.post('/merchantProductsCategory/queryList',data).then(res => {
        if(res.data.code == 200) {
           this.categoryTreeDate = res.data.data
         }
      })
    },
    //树选择
    handleCheckChange(checkedNodes, checkedKeys){
        console.log(checkedNodes, checkedKeys);
        this.selectCategoryList = checkedKeys.checkedNodes
    },
    //添加活动时间
    addUseDate(){
      this.activeTimeList.push({startTime:'',endTime:''})
    },
    //减少活动时间
    reduceActiveDate(index){
        if (this.activeTimeList.length == 1) {
            this.$message.error('不可删除')
            return
        }
       this.activeTimeList.splice(index,1)
    },
    //添加不可用时间段
    addUnuseDate(){
      this.unuseDateList.push({time:[]})
    },
    //减少不可用时段
    reduceUnuseDate(index){
      this.unuseDateList.splice(index,1)
    },
    //时间设置更多
    showMoreTime() {
      this.isShowMoreTime = !this.isShowMoreTime;
      if (this.isShowMoreTime == true) {
        this.moreTimeText = "收起";
      } else {
        this.moreTimeText = "展开";
      }
    },
    handleCheckAllChange(val) {
      this.checkedDays = val ? this.days : [];
      this.isIndeterminate = false;
    },
    handleCheckedDaysChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.days.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.days.length;
    },
    go(val) {
      let box = document.querySelectorAll(".scroll")[0];
      box.scrollTop = val;
    },
  },
};
</script>

<style lang="less" scoped>
.allBox {
  height: 100%;
  background: #fff;
  .title {
    padding: 6px 20px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
    i,
    span {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .href {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid rgb(229, 229, 229);
    overflow: hidden;
    padding-left: 4px;
    // padding: 6px 20px;
    .item {
      padding: 7px 16px;
      overflow: hidden;
      color: rgb(51, 51, 51);
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      span {
        cursor: pointer;
        transition: all 0.3s ease 0s;
      }
      span:hover {
        color: rgb(255, 96, 0);
      }
    }
  }
  .mainBox {
    padding: 24px;
    .card {
      border: 1px solid rgb(232, 232, 232);
      border-radius: 2px;
      transition: all 0.3s ease 0s;
      .cardBody {
        padding: 24px;
        display: flex;
        .left {
          margin-right: 16px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .right {
          .top {
            margin-bottom: 8px;
            overflow: hidden;
            color: rgb(51, 51, 51);
            font-weight: 500;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .bottom {
            color: rgb(102, 102, 102);
            font-size: 14px;
          }
        }
      }
    }
  }
}
.textTitle {
  position: relative;
  right: 24px;
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;
  width: max-content;
  border-left: none;
  margin-bottom: 16px;
  margin-top: 16px;
  background-image: linear-gradient(
    270deg,
    rgba(255, 189, 0, 0),
    rgba(255, 202, 0, 0.14) 49%,
    rgba(255, 208, 0, 0.3)
  );
  color: rgb(34, 34, 34);
  font-weight: 500;
  border: none;
}
.diaBox {
  margin-top: 8px;
  background: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 16px;
  margin-left: 112px;
  .inner {
    display: flex;
    .left {
      display: flex;
      width: 120px;
      justify-content: flex-end;
      color: #333;
      font-size: 14px;
    }
    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      color: #333;
      font-size: 14px;
      .top {
        .select {
          color: #ff6000;
          cursor: pointer;
        }
        .c9 {
          color: #999;
        }
      }
      .bottom {
        max-height: 84px;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        // border: 1px solid rgb(229, 229, 229);
        padding: 5px;
        padding-bottom: 4px;
        line-height: 32px;
        background-color: #fff;
        .item {
          box-sizing: border-box;
          color: rgb(51, 51, 51);
          height: auto;
          margin: 6px 8px 0px 0px;
          padding: 0px 7px;
          font-size: 12px;
          line-height: 20px;
          white-space: nowrap;
          background: rgb(250, 250, 250);
          border: 1px solid rgb(229, 229, 229);
          border-radius: 4px;
          cursor: default;
          user-select: none;
        }
      }
    }
  }
}
/deep/ .el-form-item__label::after,
.pcfn::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}
/deep/ .labelMore {
  color: rgb(102, 102, 102);
  font-size: 14px;
}
/deep/ .scroll {
  height: calc(100vh - 220px);
  overflow: auto;
  scroll-behavior: smooth;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ffbd00;
}
/deep/ .el-checkbox__input.is-checked {
  .el-checkbox__inner {
    background-color: #ffbd00;
    border-color: #ffbd00;
  }
}
/deep/ .el-checkbox__inner:hover {
  border-color: #ffbd00;
}
/deep/ .el-checkbox__inner:active {
  border-color: #ffbd00;
}
/deep/ .el-checkbox__label {
  color: #606266 !important;
}
/deep/ .el-radio__label {
  color: #606266 !important;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #ffbd00;
  border-color: #ffbd00;
}
/deep/ .f6 {
  color: #ff6000;
  font-size: 14px;
  cursor: pointer;
}
/deep/ .flexLabel > div {
  display: flex;
}
/deep/ .el-checkbox__input.is-indeterminate {
  .el-checkbox__inner {
    background-color: #fff;
    border-color: #dcdfe6;
  }
}
/deep/ .el-checkbox:last-of-type,
.el-checkbox {
  margin-right: 10px;
}
/deep/ .suffixIcon {
  padding: 0 11px;
  // background-color: rgb(250,250,250);
  color: #333;
  // border-radius: 4px;
  // border: 1px solid rgb(229,229,229);
}
/deep/ label.el-radio {
  margin-right: 16px;
}
::-webkit-scrollbar-thumb {
  background: #ccc;
}
/deep/ .myTextArea {
  textarea {
    height: 77px;
    color: #333;
    font-size: 14px;
  }
  textarea:focus {
    border-color: #ffbd00;
  }
}
/deep/ .el-button.is-circle {
  border-radius: 50%;
  margin-left: 8px;
  background-color: #ffbd00;
  height: 24px;
  width: 24px;
  i {
    font-weight: 700;
    transform: translate(-2px, -1px);
    color: #000;
  }
  i:hover {
    color: #000;
  }
}
.save {
  padding: 10px 32px;
  text-align: right;
  background: transparent;
  border-top: 1px solid rgb(232, 232, 232);
  border-radius: 0px 0px 4px 4px;
  display: flex;
  justify-content: right;
  font-weight: 400;
  .sumbit {
    background-color: #ffbd00;
    color: #000;
  }
  .sumbit:hover {
    opacity: 0.8;
  }
  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
}

/deep/.el-main {
  height: 100vh;
}
.hasSelectBox{
   display: flex;
   justify-content: space-between;
   margin-top: 10px;
}
.pd24{
    padding: 24px;
}
.nameItem{
      margin: 0px 3px 3px 0px;
}
.select {
          color: #ff6000;
          cursor: pointer;
 }
 .mr5{
    margin-right: 5px;
    margin-bottom: 5px;
 }
   .sumbit {
    background-color: #ffbd00;
    border: none;
    color: #000;
  }
  .sumbit:hover {
    opacity: 0.8;
  }
  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
</style>